/**
 * Линейка индексов над строкой для тренажёра срезов.
 * Отрицательные индексы снизу — только если showNegative.
 */
export default function TrainerSliceRuler({ text = '', showNegative = false }) {
  const chars = Array.from(text ?? '');
  const n = chars.length;
  if (!n) {
    return (
      <div className="trainer-slice-ruler" role="img" aria-label="пустая строка">
        <code className="trainer-slice-empty">''</code>
      </div>
    );
  }

  return (
    <div
      className="trainer-slice-ruler"
      role="img"
      aria-label={`строка ${text}`}
    >
      <div className="trainer-slice-ruler-scroll">
        <div
          className="trainer-slice-ruler-grid"
          style={{ gridTemplateColumns: `repeat(${n}, minmax(1.6rem, 1.6rem))` }}
        >
          {chars.map((_, i) => (
            <span key={`p${i}`} className="trainer-slice-idx trainer-slice-idx-pos">
              {i}
            </span>
          ))}
          {chars.map((ch, i) => (
            <span key={`c${i}`} className="trainer-slice-char">
              {ch}
            </span>
          ))}
          {showNegative &&
            chars.map((_, i) => (
              <span key={`n${i}`} className="trainer-slice-idx trainer-slice-idx-neg">
                {i - n}
              </span>
            ))}
        </div>
      </div>
    </div>
  );
}
